module.exports = __webpack_public_path__ + "static/img/no.7de91001.png";